export interface SavedReportsTranslation {

  // code picker
  search: string;
  manage_options: string;

  // form saved reports
  hide_details: string;
  show_details: string;

  // saved report
  add_report: string;
  add_reports: string;
  add_report_by_id: string;
  add_new_report: string;
  show_disabled_elements: string;

  // saved report menu
  edit_report: string;
  remove: string;
  remove_all: string;
  move_up: string;
  move_down: string;

  // saved report modal
  add_saved_reports_title: string;
  disabled: string;
  saved_report: string;
  my_saved_report: string;
  saved_report_info: string;
  saved_report_id: string;
  saved_report_hint: string;
  minWidth: string;
  height: string;
  done: string;

  // saved report modal validation
  saved_id_validation: string;
  min_width_validation: string;

  // general validation
  must_be_filled_out: string;
  must_be_within_range: string;

  fields_are_filled_out_incorrectly: string;
}

export interface SavedReportsEndpoints {
  savedReportEvaluation: string;
  savedReportsOptions: string;
}

export const defaultWidth = 500;
export const minWidth = 200;

export const statisticalReport = 3;
